import script from "./previewOtherTax.vue?vue&type=script&setup=true&lang=js"
export * from "./previewOtherTax.vue?vue&type=script&setup=true&lang=js"

import "./previewOtherTax.vue?vue&type=style&index=0&id=8488969c&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8488969c"]])

export default __exports__